import styled from 'styled-components';
import { spacing } from '@material-ui/system';
import { Paper as MuiPaper } from '@material-ui/core';

const Paper = styled(MuiPaper)(spacing);

export default Paper;
